import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { CustomTableData, CustomDropDown } from 'common'
import { TooltipInformation } from 'common'
import TooltipAprobacion from 'common/TooltipAprobacion/TooltipAprobacion'
import { FileText, Info, Trash2 } from 'react-feather'


const DepositTable = ({ useFetchInit }) => {

    const {
        globalStates,
        FetchData,
        Actions
    } = useFetchInit


    const { fetchAllDeposits } = FetchData
    const { deposits } = fetchAllDeposits

    const { handleClickDeleteDeposit, handleClickFetchInfoDeposit, handleClickDownloadTicket } = Actions
    const { modalOpeningMode, formOpeningMode } = globalStates




    const columnConfig = [
        {
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { iddeposit, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <>
                        <TooltipInformation
                            idregistro={iddeposit}
                            usuario_creo={usuario_creo}
                            fecha_creo={fecha_creo}
                            usuario_modifico={usuario_modifico}
                            fecha_modifico={fecha_modifico}
                        />
                    </>

                )
            }
        },
        {
            field: "deposito_fecha",
            headerName: "FECHA",
            minWidth: 130,
            maxWidth: 130,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
        },
        { field: "movimiento_tipo", headerName: "TIPO DE TRANSFERENCIA", minWidth: 220, filter: true },
        { field: "banco", headerName: "BANCO", minWidth: 130, filter: true },
        { field: "boleta_numero", headerName: "No. BOLETA", minWidth: 180, filter: true },
        { field: "deposito_moneda", headerName: "MONEDA", minWidth: 130, filter: true },
        { field: "deposito_tipo_cambio", headerName: "CAMBIO", minWidth: 130, filter: true },
        { field: "deposito_quetzal", headerName: "TOTAL (Q)", minWidth: 130, filter: true },
        { field: "deposito_dolares", headerName: "TOTAL ($)", minWidth: 130, filter: true },
        {
            field: "aprobacion_check",
            headerName: "APROBACION",
            minWidth: 200,
            maxWidth: 200,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
            cellClass: (params) => {

                if (params.value === 'APROBADO') return 'bg-success';
                if (params.value === 'PENDIENTE') return 'bg-warning';
                if (params.value === 'RECHAZADO') return 'bg-danger';

            },
            cellRenderer: (params) => {
                const { value } = params
                const { idcontrato, aprobacion_usuario, aprobacion_fecha } = params.data

                if (value === 'APROBADO') return (
                    <TooltipAprobacion
                        tag_id='tooltip_arr_solicitudes_aprobacion_'
                        class_icon='fa-solid fa-circle-check'
                        text_span='APROBADO'
                        idcontrato={idcontrato}
                        aprobacion_usuario={aprobacion_usuario}
                        aprobacion_fecha={aprobacion_fecha}
                    />
                );

                if (value === 'PENDIENTE') return (
                    <TooltipAprobacion
                        tag_id='tooltip_arr_solicitudes_aprobacion_'
                        class_icon='fa-solid fa-circle-check'
                        text_span='PENDIENTE'
                        idcontrato={idcontrato}
                        aprobacion_usuario={aprobacion_usuario}
                        aprobacion_fecha={aprobacion_fecha}
                    />
                );

                if (value === 'RECHAZADO') return (
                    <TooltipAprobacion
                        tag_id='tooltip_arr_solicitudes_aprobacion_'
                        class_icon='fa-solid fa-circle-xmark'
                        text_span='RECHAZADO'
                        idcontrato={idcontrato}
                        aprobacion_usuario={aprobacion_usuario}
                        aprobacion_fecha={aprobacion_fecha}
                    />
                );

            }
        },
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: (params) => {
                const { iddeposit, boleta_foto_path, aprobacion_check, estado } = params.data
                return (
                    < CustomDropDown color={(estado === 1) ? 'inherit' : 'error'}>
                        <MenuItem
                            onClick={() => handleClickFetchInfoDeposit(iddeposit)}
                        >
                            <ListItemIcon> <Info color="black" /> </ListItemIcon>
                            <ListItemText primary="Ver Detalles" />
                        </MenuItem>
                        <MenuItem
                            onClick={() => handleClickDownloadTicket(iddeposit)}
                        >
                            <ListItemIcon> <FileText color="black" /> </ListItemIcon>
                            <ListItemText primary="Recibo" />
                        </MenuItem>
                        {((aprobacion_check === 'PENDIENTE') && (formOpeningMode === 'EDITABLE')) && (
                            <MenuItem
                                onClick={() => handleClickDeleteDeposit(iddeposit)}
                            >
                                <ListItemIcon> <Trash2 color="black" /> </ListItemIcon>
                                <ListItemText primary="Eliminar" />
                            </MenuItem>
                        )}
                    </CustomDropDown >
                )
            }
        },
    ]

    return (
        <div className='content'>
            <CustomTableData
                rowConfig={deposits}
                // rowConfig={[]}
                columnConfig={columnConfig}
            />
        </div>
    )
}

export {
    DepositTable
}